import _ from 'lodash';
import moment from 'moment-timezone';
import { unserialize } from 'php-serialize';
import CONSTANTS from '../constants';
import LocationService from '../services/LocationService';
import OrderTypeHelper from './OrderTypeHelper';

export default class TimeHelper {
  static getDateFromTimeOption(timeOption, time) {
    if (!time) {
      return;
    }
    if (typeof time === 'string') {
      time = new Date(time);
    }
    let date;
    let newTime = new Date(time.getTime());
    switch (timeOption) {
      case CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY:
        date = new Date();
        break;
      case CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TOMORROW:
        let newDate = new Date();
        newDate.setDate(newDate.getDate() + 1);
        date = newDate;
        break;
      default:
        date = new Date(timeOption);
        break;
    }

    newTime.setDate(date.getDate());
    newTime.setMonth(date.getMonth());
    newTime.setFullYear(date.getFullYear());
    return newTime;
  }

  static differenceFromNow(dateObject) {
    return moment(dateObject).unix() - moment().unix();
  }

  static getUTCDateString(date) {
    return moment(date).utc().format('YYYY-MM-DD');
    // if (!dateTime) return '';
    // timezone = timezone.substring(0, timezone.length - 7);
    // return momentTimezone
    //   .utc(dateTime)
    //   .tz(timezone)
    //   .format('YYYY-MM-DD');
  }
  static getDateString(date) {
    return moment(date).format('YYYY-MM-DD');
  }
  static getDateStringFormat(date) {
    return moment(date).format('ddd D MMM');
  }
  static getUTCDateStringFormat(date) {
    return moment(date).utc().format('ddd D MMM');
  }

  static getUTCTimeString(date) {
    return moment(date).utc().format('HH:mm:ss');
  }
  static getTimeString(date) {
    return moment(date).format('HH:mm:ss');
  }

  static getLocalDateTimeFromUTCString(dateTime) {
    return moment.utc(dateTime, CONSTANTS.DATE_TIMES.FORMAT.DB).local();
  }

  static formattedDateTime(dateTime, format = null) {
    return moment(dateTime, format).format(CONSTANTS.DATE_TIMES.FORMAT.DISPLAY);
  }

  static formattedTime(time, format = null) {
    return moment(time, format).format(CONSTANTS.TIMES.FORMAT.DISPLAY);
  }

  static getWorkingHourType(orderType) {
    return CONSTANTS.ORDERS.VARIABLES.WORKING_HOURS[orderType];
  }

  static getWorkingHour(workingHours, weekday, orderType) {
    weekday = weekday - 1; // Minus 1 because db weekdays start from 0
    let workingHourType = this.getWorkingHourType(orderType);
    let res = workingHours.find(
      (wh) => parseInt(wh.weekday, 10) === weekday && wh.type === workingHourType
    );
    return res;
  }

  static getLatestWorkingHour(workingHours, weekday, orderType) {
    weekday = weekday - 1; // Minus 1 because db weekdays start from 0
    let workingHourType = this.getWorkingHourType(orderType);
    let res = workingHours.filter( // Changed from find to filter to return all matching entries
      (wh) => parseInt(wh.weekday, 10) === weekday && wh.type === workingHourType
    );
    return res; // Now returns an array of matching working hours
  }
  static getOpeningHours(
    location,
    weekday,
    orderType = CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DELIVERY
  ) {
    let options = location ? unserialize(location.options) : [];
    let date = moment().isoWeekday(weekday).format('YYYY-MM-DD')
    let events = options && options.opening_hours ? options.opening_hours.events : [];
    let event_holidays = options && options.opening_hours ? options.opening_hours.event_holidays : [];
    if (event_holidays && event_holidays.length > 0) {
      for (let i = 0; i < event_holidays.length; i++) {
        for (let j = 0; j < event_holidays[i].multipleDates.length; j++) {
          if (
            moment(date).isSame(
              moment(event_holidays[i].multipleDates[j]).format(CONSTANTS.DATES.FORMAT.DB)
            )
          ) {
            return 'Closed';
          }
        }
      }
    }

    let workingHours = location.workingHours;

    if (events && events.length > 0) {
      let eventsMap = new Map();

      for (let event of location.SpecialEvents) {
        let key = `${event.event_name}-${event.weekday}`;
        eventsMap.set(key, event);
      }
      for (let i = 0; i < events.length; i++) {
        let startDate = moment(events[i].event_start_date);
        let endDate = moment(events[i].event_end_date);
        while (startDate <= endDate) {
          const dayIndex = startDate.day();
          const weekday = dayIndex === 0 ? 6 : dayIndex - 1;
          let eventWorkingHours = _.filter(location.SpecialEvents, function (item) {
            return item.event_name === options.opening_hours.events[i].event_name && item.weekday === weekday;
          });
          workingHours = _.reject(workingHours, function (item) {
            return _.some(eventWorkingHours, function (eventHour) {
              return item.weekday === eventHour.weekday && item.type === eventHour.type;
            });
          });
          workingHours = workingHours.concat(eventWorkingHours);
          workingHours = _.sortBy(workingHours, ['weekday', 'type']);
          startDate.add(1, 'day');
        }
      }
    }

    let today = this.getLatestWorkingHour(workingHours, weekday, orderType);
    if (!today) return 'Closed';
    const timezone = location.timezone.substring(0, location.timezone.length - 7);
    const restaurantTiming = this.formatSingleRestaurantTiming(today, timezone, orderType);
    return restaurantTiming;
  }

  static formatSingleRestaurantTiming(workingHours, userTimezone, type, openingType) {
    // Filter for the opening hours
    let order_type = this.getWorkingHourType(type);
    const openingHours = workingHours.filter(hour => hour.type === order_type);

    if (openingHours.length === 0) return 'Closed'; // Handle case with no opening hours

    // Get the first opening hour
    const firstOpening = openingHours[0];
    const openingTime = moment.tz(firstOpening.opening_time, 'HH:mm:ss', 'UTC').tz(userTimezone).format('hh:mm A');

    // Get the closing time from the last opening hour
    const lastClosing = openingHours[openingHours.length - 1];
    const closingTime = moment.tz(lastClosing.closing_time, 'HH:mm:ss', 'UTC').tz(userTimezone).format('hh:mm A');

    // Check if closing time is earlier than opening time (indicating it crosses midnight)
    const isNextDay = moment.tz(lastClosing.closing_time, 'HH:mm:ss', 'UTC').isBefore(moment.tz(firstOpening.opening_time, 'HH:mm:ss', 'UTC'));

    return openingType === '24/7' ? `${moment(firstOpening.opening_time, 'HH:mm').format('hh:mm A')} - ${moment(lastClosing.closing_time, 'HH:mm').format('hh:mm A')}${isNextDay ? '*' : ''}` : `${openingTime} - ${closingTime}${isNextDay ? '*' : ''}`;
  }

  static formatRestaurantTiming(workingHours, userTimezone, type, openingType) {
    // Filter for the opening hours
    let order_type = this.getWorkingHourType(type);

    const openingHours = workingHours.filter(hour => hour.type === order_type);

    if (openingHours.length === 0) return 'Closed'; // Handle case with no opening hours

    // Get the first opening hour
    const firstOpening = openingHours[0];
    const openingTime = moment.tz(firstOpening.opening_time, 'HH:mm:ss', 'UTC').tz(userTimezone).format('hh:mm A');

    // Get the closing time from the last opening hour
    const lastClosing = openingHours[openingHours.length - 1];
    const closingTime = moment.tz(lastClosing.closing_time, 'HH:mm:ss', 'UTC').tz(userTimezone).format('hh:mm A');

    const midnight = moment('11:00 AM', 'hh:mm A');
    const closingTimeCheck = moment(closingTime, 'hh:mm A');

    return openingType === '24/7' ? `${moment(firstOpening.opening_time, 'HH:mm').format('hh:mm A')} - ${moment(lastClosing.closing_time, 'HH:mm').format('hh:mm A')}` : `${openingTime} - ${closingTime}${closingTimeCheck.isBefore(midnight) ? '*' : ''}`;
  }



  static getRestaurantTimingsFor(workingHours, date, orderType, options = null) {
    let computedWorkingHours = this.computeSlots(workingHours, date, orderType, options?.order_lead_time, options?.order_max_time);
    return computedWorkingHours;
  }

  static computeSlots(workingHours, date, orderType, order_lead_time, order_max_time) {
    let order_type = this.getWorkingHourType(orderType);
    if (workingHours.length > 0) {
      const res = workingHours
        .filter(entry => {
          return entry.type === order_type;
        })
        .map(hour => {
          return this.calculateTimeSlots(hour, hour.opening_time, hour.closing_time, hour.opening_day, hour.closing_day, date)
        });
      return res.flat();
    }

  }

  static calculateTimeSlots(hour, opening_time, closing_time, opening_day, closing_day, current_time) {
    // Initialize the result array
    let result = [];

    // Get the current weekday (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    const current_weekday = current_time.day() - 1;

    // Create moment objects for today's date
    const today = current_time.format('YYYY-MM-DD');

    // Create opening and closing time objects
    const openingTime = moment.utc(`${today} ${opening_time}`);
    const closingTime = current_weekday === closing_day ? moment.utc(`${today} ${closing_time}`) : moment.utc(`${today} ${closing_time}`).add(1, 'days'); // Closing time is on the next day

    // If the opening day and closing day are the same
    if (opening_day === closing_day) {
      const openingTimeSame = moment.utc(`${today} ${opening_time}`);
      const closingTimeSame = moment.utc(`${today} ${closing_time}`)
      result.push({
        startTime: openingTimeSame,  // Opening Time
        endTime: closingTimeSame     // Closing Time
      });
    } else {
      // If the current day is the opening day
      if (current_weekday === opening_day) {
        result.push({
          startTime: openingTime.clone(),               // Opening Time
          endTime: moment.utc(`${today} 23:59:59`)     // End of today
        });
      }

      // If the current day is the closing day
      if (current_weekday === closing_day) {
        result.push({
          startTime: moment.utc(`${moment(closingTime).format('YYYY-MM-DD')} 00:00:00`), // Midnight of the closing day
          endTime: closingTime.clone()                 // Closing Time on the next day
        });
      }

      // Time slot from opening time on the opening day to end of the opening day
      if (current_weekday < opening_day || current_weekday > closing_day) {
        result.push({
          startTime: openingTime.clone(),               // Opening Time
          endTime: moment.utc(`${today} 23:59:59`)     // End of today
        });
      }

    }

    return result;
  }

  static async setOrderTimeToLatestPossible(orderData, location) {

    let timeData = await LocationService.fetchServerTime();
    let currentTime = this.convertServerTimeToUserTime(timeData.serverTime);
    const is_custom_time = localStorage.getItem('is_custom_time');
    const is_asap = localStorage.getItem('is_asap');
    let orderType = null;
    let restaurantTimings = [];
    let options = location ? unserialize(location.options) : [];
    options.order_lead_time = location.order_lead_time;
    options.order_max_time = location.order_max_time;
    let events = options && options.opening_hours ? options.opening_hours.events : [];
    let workingHours = location.workingHours;

    const updatedData = JSON.parse(JSON.stringify(orderData));
    updatedData.serverTime = timeData.serverTime;
    const { order_type_id: orderTypeId } = orderData;

    if (orderTypeId && location.workingHours) {
      orderType = OrderTypeHelper.getOrderType(location.orderTypes, orderTypeId);
      let event_holidays = options && options.opening_hours ? options.opening_hours.event_holidays : [];

      if (event_holidays && event_holidays.length > 0) {
        for (let i = 0; i < event_holidays.length; i++) {
          for (let j = 0; j < event_holidays[i].multipleDates.length; j++) {
            let eventDate = moment(event_holidays[i].multipleDates[j]);
            if (eventDate.isBefore(moment(), 'day')) {
              continue;
            }
            if (event_holidays[i].multipleDates.length - 1 === j) {
              let targetDay = moment(currentTime).add(2, 'days');

              while (
                targetDay.isoWeekday() > 5 ||
                event_holidays[i].multipleDates.includes(targetDay.format('YYYY-MM-DD'))
              ) {
                targetDay.add(1, 'days');
              }
              let orderTime = moment(this.convertServerTimeToUserTime(orderData.order_time));
              updatedData.isPickUpNow = 2;
              updatedData.current_time = moment(currentTime).startOf('minute').toDate();
              updatedData.order_time = orderTime.toDate();
              updatedData.order_date = targetDay.format('YYYY-MM-DD'); // Update as necessary
              return updatedData;
            }
          }
        }
      }


      if (events && events.length > 0) {
        let eventsMap = new Map();

        for (let event of location.SpecialEvents) {
          let key = `${event.event_name}-${event.weekday}`;
          eventsMap.set(key, event);
        }
        for (let i = 0; i < events.length; i++) {
          let startDate = moment(events[i].event_start_date);
          let endDate = moment(events[i].event_end_date);
          while (startDate <= endDate) {
            const dayIndex = startDate.day();
            const weekday = dayIndex === 0 ? 6 : dayIndex - 1;
            let eventWorkingHours = _.filter(location.SpecialEvents, function (item) {
              return item.event_name === options.opening_hours.events[i].event_name && item.weekday === weekday;
            });
            workingHours = _.reject(workingHours, function (item) {
              return _.some(eventWorkingHours, function (eventHour) {
                return item.weekday === eventHour.weekday && item.type === eventHour.type;
              });
            });
            workingHours = workingHours.concat(eventWorkingHours);
            workingHours = _.sortBy(workingHours, ['weekday', 'type']);
            startDate.add(1, 'day');
          }
        }
      }
      orderType = OrderTypeHelper.getOrderType(location.orderTypes, orderTypeId);
      restaurantTimings = this.getRestaurantTimingsFor(workingHours, currentTime, orderType.order_type);
    }
    if (location.order_lead_time !== 0) {

      if (currentTime.unix() < restaurantTimings[0].startTime.unix()) {
        updatedData.isPickUpNow = 2;
      } else {
        if (this.differenceFromNow(updatedData.order_time) > 60) {
          updatedData.isPickUpNow = 2;
          return updatedData;
        }
      }
      updatedData.current_time = moment(currentTime).startOf('minute').toDate();
      updatedData.order_time = restaurantTimings[0].startTime.toDate();
      //updatedData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY;
      return updatedData;
    }

    if (location.is_master_venue) {
      updatedData.isPickUpNow = 1
      updatedData.current_time = moment(currentTime).startOf('minute').toDate();
      updatedData.order_time = currentTime.toDate();
      updatedData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY;
      return updatedData;
    }

    if (parseInt(is_asap) === 1) {
      updatedData.isPickUpNow = 1;
      updatedData.current_time = currentTime.toDate();
      updatedData.order_time = currentTime.toDate()
      updatedData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY;
      return updatedData;
    }


    if (location.is_adv_ordering === 1) {
      if (restaurantTimings.length !== 0) {
        // Get the latest timing information

        if (restaurantTimings.some(timing => currentTime.isBetween(timing.startTime, timing.endTime, null, '[]')) && parseInt(is_custom_time) === 0) {
          // Don't set isPickUpNow to 1 and don't update the order_time to the current time if timings have changed
          updatedData.isPickUpNow = 1;
          updatedData.current_time = currentTime.toDate();
          updatedData.order_time = currentTime.toDate()
          updatedData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY;
          return updatedData;
        }
        // Handle cases where current time is not within the latest restaurant timings
        if (!restaurantTimings.some(timing => currentTime.isBetween(timing.startTime, timing.endTime, null, '[]'))) {
          if (orderData.order_date === CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY) {
            updatedData.isPickUpNow = 2;
            updatedData.current_time = currentTime.toDate();
            if (restaurantTimings.some(timing => currentTime.isBefore(timing.startTime, timing.endTime, null, '[]'))) {
              let orderTime = currentTime;
              let restaurantStartTime = moment(this.convertServerTimeToUserTime(restaurantTimings[0].startTime.toDate())).toDate();
              updatedData.order_time = orderTime.isAfter(restaurantTimings[0].startTime.toDate())
                ? orderTime
                : restaurantStartTime;
              updatedData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY;
            } else {
              let orderTime = restaurantTimings[0].startTime.add(1, 'days').toDate();
              updatedData.order_time = orderTime;
              updatedData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TOMORROW;
            }
            return updatedData;
          } else if (orderData.order_date !== CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY && orderData.order_date !== CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TOMORROW) {
            // Handle custom date case here
            let selectedTime = TimeHelper.getDateFromTimeOption(
              orderData.order_date,
              orderData.order_time
            );
            selectedTime = moment(this.convertServerTimeToUserTime(selectedTime)).toDate();
            if (TimeHelper.differenceFromNow(selectedTime) < 60) {
              // Do not set isPickUpNow or modify the current time
              updatedData.isPickUpNow = 2;
              updatedData.current_time = moment(currentTime).startOf('minute').toDate();
              updatedData.order_time = selectedTime;
              updatedData.order_date = orderData.order_date; // Keep the custom date
            } else {
              updatedData.isPickUpNow = 2;
              updatedData.current_time = moment(currentTime).startOf('minute').toDate();
              updatedData.order_time = selectedTime;
              updatedData.order_date = orderData.order_date; // Keep the custom date
            }
            return updatedData;
          }
        } else {
          let selectedTime = TimeHelper.getDateFromTimeOption(
            orderData.order_date,
            orderData.order_time
          );
          selectedTime = moment(this.convertServerTimeToUserTime(selectedTime)).toDate();
          if (TimeHelper.differenceFromNow(selectedTime) < 60) {
            // Do not set isPickUpNow or modify the current time
            updatedData.isPickUpNow = 2;
            updatedData.current_time = moment(currentTime).startOf('minute').toDate();
            updatedData.order_time = selectedTime;
            updatedData.order_date = orderData.order_date; // Keep the custom date
            return updatedData;
          }
        }
      } else {
        updatedData.isPickUpNow = 2;
        updatedData.current_time = currentTime.toDate();
        updatedData.order_time = currentTime.toDate()
        updatedData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TOMORROW;
        return updatedData;
      }

      return updatedData;
    }
    else {
      let start = moment(currentTime).startOf('day');
      let end = moment(currentTime).endOf('day');

      if (!this.isTimeDisabled(currentTime, currentTime, restaurantTimings)) {
        updatedData.isPickUpNow = 1
        updatedData.current_time = moment(currentTime).startOf('minute').toDate();
        updatedData.order_time = currentTime.toDate();
        updatedData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY;
        return updatedData;
      }

      while (start.unix() < end.unix()) {
        if (!this.isTimeDisabled(start, currentTime, restaurantTimings)) {
          updatedData.isPickUpNow = 2;
          updatedData.current_time = currentTime.toDate();
          updatedData.order_time = start.toDate();
          updatedData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY;
          return updatedData;
        }
        start.add(15, 'minutes');
      }
      if (restaurantTimings.length !== 0) {
        if (currentTime.isAfter(restaurantTimings[0].endTime)) {
          start = moment(currentTime).add(1, 'days').startOf('day');
          end = moment(currentTime).add(1, 'days').endOf('day');
          while (start.unix() < end.unix()) {
            if (!this.isTimeDisabled(start, currentTime, restaurantTimings)) {
              updatedData.isPickUpNow = 2;
              updatedData.current_time = currentTime.toDate();
              updatedData.order_time = restaurantTimings[0].startTime.toDate();
              updatedData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TOMORROW;
              return updatedData;
            } else {
              updatedData.isPickUpNow = 2;
              updatedData.current_time = currentTime.toDate();
              updatedData.order_time = restaurantTimings[0].startTime.toDate();
              updatedData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TOMORROW;
              return updatedData;
            }
          }
        }
      } else {
        updatedData.isPickUpNow = 2;
        updatedData.current_time = currentTime.toDate();
        updatedData.order_time = currentTime.toDate()
        updatedData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TOMORROW;
        return updatedData;
      }
    }
    return updatedData;
  }

  static convertServerTimeToUserTime(serverTime) {
    const userTime = moment.tz(serverTime, 'UTC');
    return userTime;
  }


  static async isNowEnabled(location, orderTypeId) {
    if (orderTypeId && location.workingHours) {
      let timeData = await LocationService.fetchServerTime();
      let currentTime = this.convertServerTimeToUserTime(timeData.serverTime);
      let restaurantTimings = {};

      let orderType = OrderTypeHelper.getOrderType(location.orderTypes, orderTypeId);
      orderType = orderType ? orderType : location.orderTypes[0];
      let options = location ? unserialize(location.options) : [];
      options.order_lead_time = location.order_lead_time;
      options.order_max_time = location.order_max_time;
      let workingHours = [];
      let newWorkingHours = [];

      if (options && options.opening_hours && options.opening_hours.events && options.opening_hours.events.length > 0) {
        for (let i = 0; i < options.opening_hours.events.length; i++) {
          if (
            moment(currentTime.format(CONSTANTS.DATES.FORMAT.DB)).isBetween(
              moment(options.opening_hours.events[i].event_start_date),
              moment(options.opening_hours.events[i].event_end_date),
              'days',
              true
            )
          ) {
            workingHours = _.filter(location.SpecialEvents, function (item) {
              return item.event_name === options.opening_hours.events[i].event_name;
            });
          } else {
            workingHours = location.workingHours;
          }
        }
      } else {
        workingHours = location.workingHours;
      }

      restaurantTimings = this.getRestaurantTimingsFor(workingHours, currentTime, orderType ? orderType.order_type : location.orderTypes[0].order_type);

      if (location.order_lead_time !== 0) {

        if (currentTime.unix() < restaurantTimings[0].startTime.unix()) {

          let leadTimings = this.getRestaurantTimingsFor(
            newWorkingHours,
            restaurantTimings[0].startTime,
            orderType ? orderType.order_type : location.orderTypes[0].order_type,
            options
          );

          if (currentTime.unix() < leadTimings[0].startTime.unix()) return false;
        }

        let time = moment.duration(location.order_lead_time, 'hours');
        let newTime = moment(currentTime.add(time).format(CONSTANTS.DATE_TIMES.FORMAT.DB));
        return !this.isTimeDisabled(newTime, currentTime, restaurantTimings);

      }
      if (restaurantTimings.some(timing => currentTime.isBetween(timing.startTime, timing.endTime, null, '[]'))) {
        return true;
      }
    }
    return false;
  }

  getHours(workingHours, weekday) {
    let filterRes = _.filter(workingHours, function (item) {
      return item.parent === weekday;
    });
    if (filterRes.length === 0) {
      filterRes = _.filter(workingHours, function (item) {
        return item.weekday === weekday;
      });
    }
    if (filterRes.length === 0) {
      filterRes = _.filter(workingHours, function (item) {
        return item.weekday !== weekday;
      });
    }
    const groupedSlots = _.groupBy(filterRes, (item) => {
      return [item['opening_time'], item['closing_time']];
    });
    const keys = Object.keys(groupedSlots);
    let hours = [];
    for (let i = 0; i < keys.length; i++) {
      let tempHours = keys[i].split(',');
      let hour = { open: tempHours[0], close: tempHours[1] };
      hours.push(hour);
    }
    return hours;
  }

  static isTimeDisabled(date, currentDate, restaurantTimings) {
    if (date.unix() < currentDate.unix() || restaurantTimings.length === 0) return true;

    let disabled = true;
    if (restaurantTimings.length > 0) {
      restaurantTimings.forEach((timing) => {
        if (date.unix() >= timing.startTime.unix() && date.unix() <= timing.endTime.unix())
          disabled = false;
      });
    }
    return disabled;
  }

  static getDisabledTimesFor(
    orderTypeId,
    date,
    options = { orderTypes: [], workingHours: [], currentTime: {}, order_lead_time: {}, order_max_time: {} }
  ) {
    let disabledTimes = [];
    let restaurantTimings,
      orderType = {};
    date = moment(date);
    let start = moment(date).startOf('day');
    let end = moment(date).endOf('day');

    if (orderTypeId && options.workingHours) {
      orderType = OrderTypeHelper.getOrderType(options.orderTypes, orderTypeId);
      restaurantTimings = this.getRestaurantTimingsFor(
        options.workingHours,
        date,
        orderType.order_type
      );
    }
    while (start.unix() < end.unix()) {
      if (this.isTimeDisabled(start, options.currentTime, restaurantTimings))
        disabledTimes.push(start.toDate());
      start.add(15, 'minutes');
    }
    return disabledTimes;
  }

  static getEnabledTimesFor(
    orderTypeId,
    date,
    options = {
      advDaysCount: 0,
      orderTypes: [],
      workingHours: [],
      eventWorkingHours: [],
      currentTime: {},
      order_lead_time: {},
      order_max_time: {},
      locOptions: {},
      events: [],
      event_holidays: []
    }
  ) {
    const enabledTimes = [];
    let restaurantTimings,
      orderType = {};
    date = moment(date).utc();
    //let start = moment(date).startOf('day');
    //let end = moment(date).endOf('day');
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    orderType = OrderTypeHelper.getOrderType(options.orderTypes, parseInt(orderTypeId));
    let workingHours = JSON.parse(JSON.stringify(options.workingHours)); // Create a deep copy

    if (options && options.events && options.events.length > 0) {
      for (let i = 0; i < options.events.length; i++) {
        if (
          moment(date.format(CONSTANTS.DATES.FORMAT.DB)).isBetween(
            moment(options.events[i].event_start_date),
            moment(options.events[i].event_end_date),
            'days',
            true
          )
        ) {
          workingHours = _.filter(options.eventWorkingHours, function (item) {
            return item.event_name === options.events[i].event_name;
          });
        } else {
          workingHours = options.workingHours;
        }
      }
    }
    let advDates = this.getAdvDates(options.advDaysCount);
    let slots = this.generateTimeSlots(advDates, workingHours, userTimezone, orderType.order_type, date);
    return slots;
  }

  static generateTimeSlots(datesArray, openingTimes, userTimezone, type, currentTime) {
    const groupedSlots = {};
    datesArray.forEach(dateStr => {
      const dateUTC = moment.utc(dateStr);
      // Find the opening schedule for the given weekday
      let order_type = this.getWorkingHourType(type);
      const schedules = openingTimes.filter(o => o.type === order_type); // Adjust weekday for 0 index
      schedules.forEach(schedule => {
        if (schedule) {

          // Compute opening and closing times
          let openingDate = dateUTC.clone().isoWeekday(schedule.opening_day + 1)
            .set({
              hour: parseInt(schedule.opening_time.split(':')[0]),
              minute: parseInt(schedule.opening_time.split(':')[1]),
              second: 0,
              millisecond: 0
            });

          let closingDate = dateUTC.clone().isoWeekday(schedule.closing_day + 1)
            .set({
              hour: parseInt(schedule.closing_time.split(':')[0]),
              minute: parseInt(schedule.closing_time.split(':')[1]),
              second: 0,
              millisecond: 0
            });


          // Handle cases where closing time is on the next day
          if (closingDate.isBefore(openingDate)) {
            closingDate.add(1, 'days');
          }

          // Generate hourly slots between opening and closing times
          let currentSlot = openingDate;
          while (currentSlot.isBefore(closingDate)) {
            // Only add slots after currentTime
            if (currentSlot.isAfter(currentTime)) {
              const dateKey = currentSlot.tz(userTimezone).format('YYYY-MM-DD'); // Get date in user timezone
              const slotTime = this.roundToNearest15(currentSlot.tz(userTimezone).toDate()); // Convert to user-defined timezone

              // Initialize the array for that date if it doesn't exist
              if (!groupedSlots[dateKey]) {
                groupedSlots[dateKey] = [];
              }
              groupedSlots[dateKey].push(slotTime); // Add the time slot to the correct date
            }
            currentSlot.add(15, 'minutes'); // Move to the next hour slot
          }
        }
      });
    });
    return groupedSlots;
  }

  static roundToNearest15(date) {
    const minutes = date.getMinutes(); // Get minutes in local timezone
    const roundedMinutes = Math.round(minutes / 15) * 15; // Round to nearest 15
    date.setMinutes(roundedMinutes, 0, 0); // Reset seconds and milliseconds
    return date;
  }

  static calDaysDiff(orderTypeId, date, options = { orderTypes: [], workingHours: [], currentTime: {}, order_lead_time: {}, order_max_time: {} }) {

    date = moment(date);
    let restaurantTimings, orderType = {};
    let days = 0;
    if (orderTypeId && options.workingHours) {
      orderType = OrderTypeHelper.getOrderType(options.orderTypes, parseInt(orderTypeId));
      restaurantTimings = this.getRestaurantTimingsFor(options.workingHours, date, orderType.order_type, options.order_lead_time, options.order_max_time);
    }
    restaurantTimings.forEach((timing) => {
      let time = moment.duration(parseInt(options.order_lead_time), 'hours');
      let now = moment(new Date());
      let start = moment(timing.startTime.subtract(time).format(CONSTANTS.DATE_TIMES.FORMAT.DB));
      let duration = moment.duration(now.diff(start));
      days = parseInt(duration.asDays());
    });
    return days;
  }

  static getAdvDates(advDays) {
    let dates = [];
    let baseDate = moment.utc();
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (advDays) {
      for (let i = 0; i < advDays; i++) {
        let currentDateInUTC = moment.utc(baseDate).add(i, 'days');  // Clone the base date and add days
        //let currentDateInUserTimezone = currentDateInUTC.tz(userTimezone).format('YYYY-MM-DD HH:mm:ss');
        dates.push(currentDateInUTC.format('YYYY-MM-DD HH:mm:ss'));
      }
      return dates;
    }
    return '';
  }
  static getDailyHours(hours = []) {
    let res = this.manageHours(hours);
    return res;
  }
  static getTimeHours(workingHours, isForNow) {
    const groupedSlots = _.groupBy(workingHours, (item) => {
      return [item['opening_time'], item['closing_time']];
    });
    const keys = Object.keys(groupedSlots);
    let hours = [];
    const currTime = moment().hour();

    keys.forEach(key => {
      const [openTime, closeTime] = key.split(',');
      const openHour = moment(openTime, 'HH:mm A').hour();
      const closeHour = moment(closeTime, 'HH:mm A').hour();
      let hour = { open: openTime, close: closeTime };

      if (isForNow || (closeHour > 12) || (openHour < 12 && currTime < 12) || (closeHour < 12 && closeHour > openHour)) {
        hours.push(hour);
      }
    });

    return hours;
  }


}
